import React from 'react'
import { motion } from 'framer-motion'
import { Home } from 'lucide-react'
import { Link } from 'react-router-dom'

const NotFoundPage = () => {
  return (
    <div className="pt-16 lg:pt-20 min-h-screen">
      <section className="section-padding py-20">
        <div className="container-max">
          <motion.div className="glass-card p-12 text-center" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <h1 className="text-5xl font-display font-bold text-white mb-4">404</h1>
            <p className="text-white/70 mb-8">We couldn't find that page.</p>
            <Link to="/" className="btn-primary inline-flex items-center gap-2"><Home size={18} />Back Home</Link>
          </motion.div>
        </div>
      </section>
    </div>
  )
}

export default NotFoundPage

